import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import PropTypes from 'prop-types';
import React from 'react';
import '../../index.scss';
import {
  getCellContents,
  getCellLabel,
  priorityCells,
  shouldShowCell,
} from '../../TableCellGenerator';

const UsersTableRow = ({
  booking,
  venue,
  onClick,
  showBookingDetailsModal,
  hideBookingDetailsModal,
}) => {
  return (
    <TableRow hover className="hover" onClick={onClick}>
      {priorityCells.map(cell => {
        const rowClass = booking.pending
          ? 'booking__row__pending'
          : booking.refunded > 0
          ? 'booking__row__refunded'
          : '';

        return shouldShowCell(cell, venue) ? (
          <TableCell
            data-label={getCellLabel(cell.className)}
            key={`${booking.id}${cell.className}`}
            className={`${cell.className} ${rowClass}`}
          >
            {getCellContents(
              cell.className,
              booking,
              venue.currency,
              showBookingDetailsModal
            )}
          </TableCell>
        ) : null;
      })}
    </TableRow>
  );
};

UsersTableRow.propTypes = {
  venue: PropTypes.object.isRequired,
  booking: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  showBookingDetailsModal: PropTypes.func.isRequired,
};

export default UsersTableRow;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/Users/ViewUsersPanel/UsersTable/UsersTableRow/index.jsx